import Vue from 'vue/dist/vue.esm';
import HotelSearch from '../hotel_search/HotelSearch.vue';
import {client} from '../hotel_search/providers/apollo';
import utils from '../hotel_search/providers/utils';
import VueI18n from 'vue-i18n';
import InlineSvg from 'vue-inline-svg';
import {prepareMessages} from '../lib/translations';

if (typeof Number.prototype.toRad === 'undefined') {
  Number.prototype.toRad = function () {
    return (this * Math.PI) / 180;
  };
}

const initialize = function () {
  const hotelSearchContainer = document.querySelector('#hotelSearch');

  if (hotelSearchContainer) {
    Vue.use(VueI18n);
    Vue.component('inline-svg', InlineSvg);
    Vue.use({
      install: Vue => {
        Vue.prototype.$utils = utils(Vue);
      },
    });

    Vue.prototype.$client = client;

    const i18n = new VueI18n({
      locale: window.locale,
      messages: prepareMessages('hotel_search'),
      fallbackLocale: 'en',
    });

    const app = new Vue({
      render: h => h(HotelSearch),
      i18n,
    }).$mount('#hotelSearch');
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize);
} else {
  initialize();
}
